<template>
  <div class="frontlogin">
    <div class="login-content">
      <div class="login_title">欢迎登录</div>
      <div class="login_form_wrapper">
        <el-form
          :model="loginForm"
          ref="loginForm"
          :rules="rules"
          label-width="10px"
          class="loginform"
        >
          <el-form-item label="" prop="username">
            <el-input
              v-model.trim="loginForm.username"
              autocomplete="off"
              max="20"
              @blur="blurPassword"
              @keyup.enter.native="submitForm('loginForm')"
              clearable
            >
              <i slot="prefix" class="el-input__icon icon-my-user"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="" prop="password">
            <el-input
              type="password"
              v-model.trim="loginForm.password"
              autocomplete="off"
              max="100"
              @keyup.enter.native="submitForm('loginForm')"
              clearable
            >
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="forgetpassword">
          <el-checkbox v-model="checked" class="fl">记住密码</el-checkbox>
          <a @click="forgetPwd()" class="btn_color">忘记密码</a>
        </div>
        <el-button
          class="login_btn"
          @click="submitForm('loginForm')"
          @keyup.enter.native="submitForm('loginForm')"
          :loading="loadingLogin"
        >
          立即登录
        </el-button>
        <div class="register">
          <a @click="register()" class="btn_color">立即注册</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import detailService from "@/service/front/detailService";
import commonService from "@/service/commonService";
export default {
  data: function () {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      checked: true,
      loadingLogin: false,
      rules: {
        username: [
          { required: true, message: "请输入登录手机号码", trigger: "blur" },
          { validator: this.$rules.phoneNumber, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入正确密码", trigger: "blur" },
        ],
      },
    };
  },
  name: "frontlogin",
  async mounted() {},
  methods: {
    blurPassword() {
      if (!this.loginForm.password) {
        let pass =  this.$cookie.get(
          "user" + this.loginForm.username
        );
        this.loginForm.password = window.atob(pass).substring(4)
      }
    },
    async fetchUserInfo() {
      let data = await detailService.fetchDetail();
      return data;
    },
    submitForm(formName) {
      this.loadingLogin = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.$cookie.set("token", this.SysConstant.basicAuth);
          try {
            await commonService.checkLogin(this.loginForm.username);
            let data = await commonService.login(this.loginForm);
            if (data) {
              this.$cookie.set(
                "token",
                data.token_type + " " + data.access_token,
                { expires: '3600s' }
              );
              let userInfo = await this.fetchUserInfo();
              userInfo.devPass = window.btoa('jkx-' + this.loginForm.password);
              userInfo.devName = this.loginForm.username;
              this.$store.commit("clearUserInfo");
              this.$store.commit("setUserInfo", userInfo);
              this.$router.push({ name: "developer" });
              if (this.checked) {
                // 记住密码
                this.$cookie.set(
                  "user" + this.loginForm.username,
                  window.btoa('jkx-' + this.loginForm.password),
                  { expires: '3D' }
                );
              } else {
                // 清空记住密码
                this.$cookie.remove("user" + this.loginForm.username);
              }
            }
          } catch (e) {
            console.log(e);
            this.$message.error(e && e.msg);
          }
        } else {
          this.$message.error("请输入正确手机号、密码");
          return false;
        }
      });
      this.loadingLogin = false;
    },
    forgetPwd() {
      this.$router.push({ name: "frontpwd" });
    },
    register() {
      this.$router.push({ name: "devregiser" });
    },
  },
};
</script>
<style scoped>
.frontlogin {
  height: 100%;
  width: 100%;
}
.frontlogin .login_title {
  height: 22px;
  margin: 50px 0px;
  font-size: 22px;
  letter-spacing: 2px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
}
.frontlogin .login-content {
  width: 1200px;
  height: 75%;
  background-color: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.08);
}
.frontlogin .login-content .login_form_wrapper {
  width: 360px;
  margin: 0 auto;
  text-align: right;
}
.frontlogin * {
  color: #333333;
}
.frontlogin .login-content .login_form_wrapper .login_btn {
  color: #fffefe;
  width: 350px;
  height: 40px;
  background: rgba(16, 142, 233, 1);
  border-radius: 6px;
  margin-bottom: 20px;
}
.frontlogin .login-content .login_form_wrapper .forgetpassword {
  text-align: right;
  color: #999999;
  margin-bottom: 20px;
  padding-left: 10px;
}
.frontlogin .login-content .login_form_wrapper .forgetpassword > a {
  color: #999999;
  text-decoration: none;
  cursor: pointer;
}
.frontlogin .login-content .login_form_wrapper .register {
  width: 360px;
  display: inline-block;
  text-align: right;
}
.frontlogin .login-content .login_form_wrapper .register > a {
  color: #999999;
  text-decoration: none;
  cursor: pointer;
}
</style>

<style type="text/css">
.frontlogin .login-content .el-form-item.is-success .el-input__inner,
.frontlogin .login-content .el-form-item.is-success .el-textarea__inner {
  border-color: #d6d6d6;
}
.frontlogin .login-content .el-form-item.is-success .el-input__inner:focus,
.frontlogin .login-content .el-form-item.is-success .el-textarea__inner:focus {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(16, 142, 233, 1);
  /*box-shadow:0px 0px 10px 0px rgba(16,142,233,0.3);*/
  border-radius: 6px;
}
.frontlogin .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  padding-top: 0px;
  position: absolute;
  line-height: 40px;
  height: 40px;
  top: 0;
  left: 360px;
  width: 200px;
  text-align: left;
}
.frontlogin .btn_color {
  color: #108ee9 !important;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.frontlogin .el-input--prefix .el-input__inner {
  padding-left: 35px;
}
.frontlogin
  .login_form_wrapper
  .forgetpassword
  .el-checkbox__input.is-checked
  + .el-checkbox__label {
  color: #666666;
  vertical-align: bottom;
}
.frontlogin .login_form_wrapper .forgetpassword .el-checkbox__label {
  color: #666666;
  vertical-align: bottom;
}

.frontlogin
  .login_form_wrapper
  .el-checkbox__input.is-checked
  .el-checkbox__inner,
.frontlogin .login_form_wrapper .el-checkbox__inner:hover,
.frontlogin .login_form_wrapper .el-checkbox__inner:focus,
.frontlogin
  .login_form_wrapper
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  background-color: transparent;
  border-color: #666666;
}
.frontlogin
  .login_form_wrapper
  .el-checkbox__input.is-checked
  .el-checkbox__inner::after {
  color: #666666;
  border-color: #666666;
}
.frontlogin .login_form_wrapper .el-checkbox__inner {
  border-color: #666666;
}
/*清除chrome表单自动填充后，input文本框的背景会变成偏黄色的*/
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset;
}
</style>



// WEBPACK FOOTER //
// src/pages/front/login/index.vue